import { Injectable } from '@angular/core';
import { PrintService } from '../apiV2/services/print.service';
import {
  ProviderResponseOfMasteredLocations,
  FacilityResponseOfMasteredLocations,
  ProviderSearchRequest, FacilitySearchRequest
} from '../apiV2/models';
import { CURRENT_TENNANT } from 'src/app/app.component';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrintPdfV2Service {

  constructor(private printService: PrintService) { }

  getPrintPdfForSingleProvider(practitionerData: ProviderResponseOfMasteredLocations): Observable<Blob> {
    return this.printService.getSingleProviderPrintPdf({
      "x-tenant-id": CURRENT_TENNANT,
      body: practitionerData,
      'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en',
    }) as Observable<Blob>
  }

  getPrintPdfForSingleFacility(facilityData: FacilityResponseOfMasteredLocations):
    Observable<Blob> {
    return this.printService.getSingleFacilityPrintPdf({
      body: facilityData,
      "x-tenant-id": CURRENT_TENNANT,
      'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en',
    }) as Observable<Blob>
  }

  getPrintPdfForAllProvider(ProviderSearchRequest: ProviderSearchRequest): Observable<Blob> {
    return this.printService.multiTenantProviderPrintAllV2CareFindr({
      "x-tenant-id": CURRENT_TENNANT,
      "x-persona": 'user',
      'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en',
      body: ProviderSearchRequest,
    }) as Observable<Blob>
  }
  getPrintPdfForAllFacility(FacilitySearchRequest: FacilitySearchRequest): Observable<Blob> {
    return this.printService.multiTenantFacilityPrintAllV2CareFindr({
      "x-tenant-id": CURRENT_TENNANT,
      "x-persona": 'user',
      'Accept-Language': localStorage.getItem('translateLanguageTo') || 'en',
      body: FacilitySearchRequest,
    }) as Observable<Blob>
  }
}
